import { Component } from '@angular/core';

@Component({
  selector: 'unauthorized-page',
  templateUrl: './console/app-js/shared/pages/unauthorized-page.component.html'
})
export class UnauthorizedPageComponent {
  protected message: string;
}
